import { createApp } from 'vue';
import App from './App.vue';
import router, { setupAuthHook } from './router';
import store from './store';
import { Modal } from 'ant-design-vue';
import 'ant-design-vue/es/modal/style/index';
import 'ant-design-vue/es/notification/style/index';
import './config';

import '@/assets/style/normalize.css';
import '@/assets/scss/antd.scss';
import '@/assets/scss/global.scss';

import 'virtual:windi.css';
import '@/url-app';
import { start } from './utils/version-upgrade';

const app = createApp(App).use(store);
app.config.globalProperties.$modal = Modal;
setupAuthHook(router);
app.use(router).mount('#main-app');
// https://juejin.cn/post/6894137504178372615

// start();
